import React, { FC } from 'react';
import { ProviderStrategyDetails } from '@app/screens/liquidity/AddLiquidityV3/components/ProviderStrategyDetails';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';
import { LiquidityWizardMinInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedMintInfo';
import { useDerivedSteerInfo } from '@app/screens/liquidity/LiquidityWizard/hooks/useDerivedSteerMintInfo';

interface Props {
  mintInfo: LiquidityWizardMinInfo;
}

export const SteerLiquidityDetails: FC<Props> = ({ mintInfo }) => {
  const { mode, provider, currencyA, currencyB, strategy } =
    useLiquidityWizardState();

  const { poolAddress } = mintInfo;

  const mintInfoWithProvider = useDerivedSteerInfo(poolAddress, currencyA);

  if (
    mode === 'auto' &&
    provider === 'steer' &&
    poolAddress &&
    currencyA &&
    currencyB
  ) {
    return (
      <ProviderStrategyDetails
        poolAddress={poolAddress}
        currencyA={currencyA}
        currencyB={currencyB}
        selectedVault={mintInfoWithProvider.selectedVault}
        provider={provider}
        hasStrategy={!!strategy}
        nftPoolAddress={mintInfoWithProvider.nftPoolAddress}
      />
    );
  }

  return null;
};
